import styled from 'styled-components';

const StyledButton = styled.button`
	border-width: 0;
	border-radius: 4px;
	padding: 5px 10px;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	color: #ffffff;
	background-color: #1678c2;
	cursor: pointer;
	transition: background-color 0.25s ease;

	&:hover {
		background-color: #2185d0;
	}

	&:focus {
		outline: 0;
	}
`;

const StyledText = styled.span`
	display: flex;
	align-items: center;
	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	color: #ffffff;
`;

export { StyledButton, StyledText };
